import { render, staticRenderFns } from "./MaterialsDialog.vue?vue&type=template&id=74a0f004&scoped=true"
import script from "./MaterialsDialog.vue?vue&type=script&lang=js"
export * from "./MaterialsDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialsDialog.vue?vue&type=style&index=0&id=74a0f004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a0f004",
  null
  
)

export default component.exports